module.exports = __webpack_public_path__ + "static/media/bg.22dc828e.png";